// extracted by mini-css-extract-plugin
export var closed = "_bk-1";
export var resizer = "_bk-0";